<div class="result-container">
  @if (loadingSnapshot) {
  <div class="loading-container">
    <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
    <p>{{ 'MESSAGE.LOADING.SNAPSHOT' | translate }}</p>
  </div>
  }

  @if (snapshotError && !loadingSnapshot) {
  <div class="error-container">
    <fa-icon [icon]="icons.faExclamationTriangle"></fa-icon>
    <p>{{ snapshotError | translate }}</p>
  </div>
  }

  @if (!loadingSnapshot && !snapshotError) {
  <div class="result-content">
    <div class="page-header">
      <div class="header-left">
        <button class="back-button" (click)="goBack()" [title]="'BUTTON.BACK' | translate">
          <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
        </button>
        <div class="header-info">
          <h1 class="page-title">
            {{ resultName || interactionName }}
            <div class="header-actions">
              <button class="header-action-button" (click)="downloadAllResultsJson()"
                [title]="'BUTTON.DOWNLOAD_ALL_JSON' | translate">
                <fa-icon [icon]="icons.faDownload"></fa-icon>
              </button>
              <button class="header-action-button" (click)="showExecutionDetails()"
                [title]="'RESULT.SHOW_EXECUTION_DETAILS' | translate">
                <fa-icon [icon]="icons.faCircleInfo"></fa-icon>
              </button>
              @if (!isBlocked && selectedArchiveId && !loadingOutputs && !outputsError) {
              <button
                class="header-action-button header-action-button--danger"
                [class.header-action-button--confirmed]="reportedUnsafe"
                [disabled]="reportingUnsafe || reportedUnsafe"
                (click)="openReportUnsafeModal()"
                [title]="'RESULT.REPORT_UNSAFE.BUTTON' | translate">
                @if (reportingUnsafe) {
                  <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
                } @else {
                  <fa-icon [icon]="icons.faFlag"></fa-icon>
                }
              </button>
              }
            </div>
          </h1>
          @if (resultDate) {
          <span class="page-subtitle">{{ resultDate }}</span>
          }
        </div>
      </div>
      <div class="file-selector-inline">
        @if (archives.length > 0) {
        <label for="archive-select" class="files-label">
          {{ 'RESULT.FILES_COUNT' | translate: { count: archives.length } }}:
        </label>
        }
        <div class="selector-controls">
          <button class="nav-button" (click)="previousArchive()" [disabled]="isFirstArchive" title="Anterior">
            <fa-icon [icon]="icons.faChevronLeft"></fa-icon>
          </button>
          <div class="select-wrapper">
            <ng-select id="archive-select" [items]="archives" bindLabel="name" bindValue="id"
              [(ngModel)]="selectedArchiveId" (ngModelChange)="onArchiveSelect()"
              [placeholder]="'PLACEHOLDER.SELECT.FILE' | translate"
              [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [clearable]="false" [searchable]="true"
              class="archive-select">
              <ng-template ng-label-tmp let-item="item">
                <span [title]="item.name">{{ item.name | truncateMiddle:30 }}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span [title]="item.name">{{ item.name | truncateMiddle:30 }}</span>
              </ng-template>
            </ng-select>
          </div>
          <button class="nav-button" (click)="nextArchive()" [disabled]="isLastArchive" title="Próximo">
            <fa-icon [icon]="icons.faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="left-panel">
        <div class="viewer-container">
          @if (loadingPreview) {
          <div class="viewer-loading">
            <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
            <p>{{ 'MESSAGE.LOADING.PREVIEW' | translate }}</p>
          </div>
          }
          @if (previewError && !loadingPreview) {
          <div class="viewer-error">
            <fa-icon [icon]="icons.faExclamationTriangle"></fa-icon>
            <p>{{ previewError | translate }}</p>
          </div>
          }
          @if (!loadingPreview && !previewError && previewPages.length > 0) {
          <app-viewer [images]="previewPages" [numOfPages]="previewMetadata?.totalPages || previewPages.length"
            [imgIndex]="viewerImgIndex" [entities]="entities" [loading]="previewBatchLoading"
            (entityClick)="onViewerEntityClick($event)" (changeImgIndex)="onPreviewPageChange($event)"></app-viewer>
          }
          @if (!loadingPreview && !previewError && previewPages.length === 0 && selectedArchiveId) {
          <div class="no-preview">
            <p>{{ 'MESSAGE.NO.PREVIEW' | translate }}</p>
          </div>
          }
        </div>
      </div>
      <div class="right-panel">
        @if (!selectedArchiveId) {
        <div class="no-selection">
          <p>{{ 'MESSAGE.SELECT.FILE.TO.VIEW.OUTPUTS' | translate }}</p>
        </div>
        }
        @if (selectedArchiveId) {
        <div class="outputs-container">
          @if (loadingOutputs) {
          <div class="outputs-loading">
            <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
            <p>{{ 'MESSAGE.LOADING.OUTPUTS' | translate }}</p>
          </div>
          }
          @if (outputsError && !loadingOutputs) {
          <div class="outputs-error">
            <fa-icon [icon]="icons.faExclamationTriangle"></fa-icon>
            <p>{{ outputsError | translate }}</p>
          </div>
          }
          @if (!loadingOutputs && !outputsError && isBlocked) {
          <div class="outputs-blocked">
            <div class="blocked-actions-bar">
              <div class="blocked-status">
                <fa-icon [icon]="icons.faShieldHalved" class="blocked-icon"></fa-icon>
                <span class="blocked-title">{{ 'RESULT.BLOCKED.TITLE' | translate }}</span>
              </div>
              <div class="blocked-badges">
                @if (blockedType) {
                <span class="blocked-type-badge">
                  {{ blockedType === 'prompt' ? ('RESULT.BLOCKED.TYPE_PROMPT' | translate) : ('RESULT.BLOCKED.TYPE_DOCUMENT' | translate) }}
                </span>
                }
                @if (blockedScore !== null) {
                <span class="blocked-score-badge">{{ (blockedScore * 100).toFixed(0) }}%</span>
                }
              </div>
            </div>

            <div class="blocked-body">
              @if (blockedChunk) {
              <div class="blocked-chunk-section">
                <p class="section-label">{{ 'RESULT.BLOCKED.CHUNK_LABEL' | translate }}</p>
                <p class="blocked-chunk-text">{{ blockedChunk }}</p>
              </div>
              }

              <div class="blocked-feedback-section">
                <p class="section-label">{{ 'RESULT.BLOCKED.FEEDBACK_QUESTION' | translate }}</p>
                @if (!feedbackSent) {
                <div class="blocked-feedback-actions">
                  <app-button
                    [text]="'RESULT.BLOCKED.MARK_UNSAFE' | translate"
                    variant="primary"
                    size="small"
                    [icon]="icons.faCheck"
                    [loading]="sendingFeedback"
                    [disabled]="sendingFeedback"
                    (clicked)="sendFeedback('unsafe')">
                  </app-button>
                  <app-button
                    [text]="'RESULT.BLOCKED.MARK_SAFE' | translate"
                    variant="secondary"
                    size="small"
                    [icon]="icons.faXmark"
                    [loading]="sendingFeedback"
                    [disabled]="sendingFeedback"
                    (clicked)="sendFeedback('safe')">
                  </app-button>
                </div>
                } @else {
                <p class="feedback-confirmed">{{ 'RESULT.BLOCKED.FEEDBACK_CONFIRMED' | translate }}</p>
                }
              </div>

              <div class="blocked-reprocess-section">
                <app-button
                  [text]="reprocessing ? ('RESULT.BLOCKED.REPROCESSING' | translate) : ('RESULT.BLOCKED.REPROCESS' | translate)"
                  variant="ghost"
                  size="small"
                  [icon]="icons.faRotateRight"
                  [loading]="reprocessing"
                  [disabled]="reprocessing"
                  (clicked)="reprocessWithoutGuard()">
                </app-button>
                @if (reprocessing) {
                <div class="reprocess-progress-wrapper">
                  <div class="reprocess-progress">
                    <div class="reprocess-progress-fill" [style.width.%]="reprocessProgress"></div>
                  </div>
                  <span class="reprocess-progress-label">
                    {{ reprocessStageLabel | translate }} {{ reprocessProgress }}%
                  </span>
                </div>
                }
                @if (reprocessError) {
                <p class="reprocess-error">{{ reprocessError | translate }}</p>
                }
              </div>
            </div>
          </div>
          }
          @if (!loadingOutputs && !outputsError && !isBlocked) {
          <div class="outputs-data">
            @if (classifications.length > 0) {
            <app-classifications-view
              [classifications]="classifications"
              (classificationClick)="onClassificationClick($event)"
              (download)="downloadJson()">
            </app-classifications-view>
            } @else {
            <app-entities-view
              [entities]="entities"
              [objects]="objects"
              [selectedEntityId]="selectedEntityId"
              [canSaveReference]="canSaveReference"
              (entityClick)="onEntityClick($event)"
              (download)="downloadJson()"
              (saveReference)="openSaveReferenceModal()">
            </app-entities-view>
            }
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>

@if (showExecutionModal) {
<app-modal-execution-details [interactionId]="interactionId" [resultId]="resultId" (close)="closeExecutionDetails()">
</app-modal-execution-details>
}

<app-modal-save-reference
  [show]="showSaveReferenceModal"
  [loading]="savingReference"
  [defaultName]="initialReferenceName"
  (close)="closeSaveReferenceModal()"
  (saved)="onReferenceSave($event)">
</app-modal-save-reference>

<app-modal-confirm
  [show]="showReportUnsafeModal"
  [title]="'RESULT.REPORT_UNSAFE.MODAL_TITLE'"
  [message]="'RESULT.REPORT_UNSAFE.CONFIRM'"
  [confirmLabel]="'RESULT.REPORT_UNSAFE.BUTTON'"
  variant="danger"
  btnVariant="danger"
  [icon]="icons.faFlag"
  [loading]="reportingUnsafe"
  (close)="closeReportUnsafeModal()"
  (confirm)="confirmReportAsUnsafe()">
  <div class="report-unsafe-target">
    <p class="report-unsafe-file">
      <strong>{{ 'RESULT.REPORT_UNSAFE.FILE_LABEL' | translate }}:</strong> {{ getArchiveName(selectedArchiveId) }}
    </p>
    <label>
      <input type="radio" name="reportTarget" value="document" [(ngModel)]="reportUnsafeTarget" />
      {{ 'RESULT.REPORT_UNSAFE.TARGET_DOCUMENT' | translate }}
    </label>
    <label>
      <input type="radio" name="reportTarget" value="prompt" [(ngModel)]="reportUnsafeTarget" />
      {{ 'RESULT.REPORT_UNSAFE.TARGET_PROMPT' | translate }}
    </label>
  </div>
</app-modal-confirm>